function isArray(value) {
	return value instanceof Array;
}

module.exports = isArray;
